import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./AppLayout.css";

export function AppLayout() {
  const { isAdmin, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="layout">
      <aside className="sidebar">
        <button
          className="sidebar__logo"
          onClick={() => navigate("/tests")}
          aria-label="Inicio"
          title="Inicio"
        >
          <img src="/logo-horse.png" alt="Equi for All" />
        </button>

        <div className="sidebar__footer">
          {isAdmin && (
            <button
              className="sidebar__icon"
              onClick={() => navigate("/admin")}
              title="Administración"
              aria-label="Administración"
            >
              ⚙
            </button>
          )}
          <button
            className="sidebar__icon"
            onClick={async () => {
              await signOut();
              navigate("/login");
            }}
            title="Cerrar sesión"
            aria-label="Cerrar sesión"
          >
            ⎋
          </button>
        </div>
      </aside>

      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
